module.exports = __webpack_public_path__ + "static/scale-model-of-dillon-house-events-in-topeka-kansas-6818f9d839603489e9b1a74c0c3aba84.png";